/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreLink = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M5.396 14.498a3.259 3.259 0 0 1-2.313-.956c-.618-.618-.958-1.439-.958-2.313s.34-1.695.958-2.313L5.411 6.59c1.235-1.236 3.391-1.237 4.626 0a.5.5 0 0 1-.707.707c-.858-.858-2.354-.857-3.212 0L3.79 9.623c-.429.429-.666.999-.666 1.606s.236 1.177.665 1.605a2.275 2.275 0 0 0 3.212 0l.313-.313a.5.5 0 0 1 .707.707l-.313.313a3.26 3.26 0 0 1-2.313.956z"
    />
    <path
      fill="currentColor"
      d="M8.883 10.894a3.259 3.259 0 0 1-2.313-.956.5.5 0 0 1 .707-.707 2.275 2.275 0 0 0 3.212 0l2.345-2.344c.429-.429.666-.999.666-1.605s-.236-1.177-.665-1.605a2.275 2.275 0 0 0-3.212 0 .501.501 0 0 1-.709-.705l.075-.076a.599.599 0 0 1 .061-.052 3.278 3.278 0 0 1 4.493.126c.618.618.958 1.439.958 2.313s-.34 1.695-.959 2.313L11.197 9.94a3.26 3.26 0 0 1-2.313.956z"
    />
  </svg>
);

IconCoreLink.displayName = 'IconCoreLink';

IconCoreLink.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreLink);
IconCoreLink.displayName = 'IconCoreLink';
